// import { InvoicePage } from "./pages/invoice-page";
import { BlockCallerPage } from "./pages/block-caller-page";
import { TestimonyPage } from "./pages/testimony-page";
import FieldSettings from './pages/field-settings'; 
import { ProfilePage } from "./pages/profile-page";
import { CallLogsPage } from "./pages/call-logs-page";
import CallForm from "./components/pastoral-care/pages/create-follow-up";
import NewFollowUp from "./components/pastoral-care/pages/new-follow-up";
import OngoingFollowUp from "./components/pastoral-care/pages/ongoing-follow-up";
import CompletedFollowUp from "./components/pastoral-care/pages/completed-follow-up";
import AllFollowUp from "./components/pastoral-care/pages/All-follow-up";
import CallLogs from "./components/pastoral-care/pages/calllogs";
import MailingResources from "./components/pastoral-care/pages/mailing-resources";
// import ChurchLocation from "./components/pastoral-care/pages/church-locations";
import DisplayFollowUp from "./components/pastoral-care/pages/display-follow-up";
import { SubscribersPage } from "./pages/subscribers-page";
import DashboardUsers from "./pages/users-list";
import AccountProfile from "./pages/account-page";

import Resources from "./components/pastoral-care/pages/fullfillment/resources";
import Inventory from "./components/pastoral-care/pages/fullfillment/inventory";
import Pastoral from "./components/pastoral-care/pages/fullfillment/pastoral";
import Agents from "./components/pastoral-care/pages/fullfillment/agents";
import ViewResourceRequest from "./components/pastoral-care/components/fullfillment/view-resource-request";
// import FullfillmentCompletion from "./components/pastoral-care/components/fullfillment/fullfillmentCompletion";
import Fulfilled from "./components/pastoral-care/pages/fullfillment/fulfilled";
import Returned from "./components/pastoral-care/pages/fullfillment/returned";
import ViewReturnedResource from "./components/pastoral-care/components/fullfillment/view-returned-resource";
import Completed from "./components/pastoral-care/pages/fullfillment/completed";
import PrayerRequestDashboard from "./components/PrayerRequestDashboard";
import MailingStatsReport from "./components/pastoral-care/components/fullfillment/MailingStatsReport";
import VoicemailDashboard from "./components/voicemail/VoicemailDashboard";
// import DepartmentConfiguration from "./components/DepartmentConfiguration";
import TypesOfCalls from "./pages/types-of-calls";
import Disposition from "./pages/disposition";
import SalvationRededication from "./pages/salvation-rededication";
import AgeGender from "./pages/age-gender";
import ResourcesPage from "./pages/resources";
import AreaCodesCalls from "./pages/area-codes-calls";
import VolunteerHours from "./pages/volunteer-hours";
import VolunteerReport from "./pages/volunteer-reports";
// import { ExtractOrganizations } from "./components/extractOrganizations";
import PrayerRequests from "./pages/prayer-requests";
import VoicemailReport from "./pages/voicemail-requests";
import { FiSettings, FiSliders} from "react-icons/fi";

export const routesConfig = [
  {
    path: "/home",
    element: <ProfilePage />,
    allowedRoles: [
      "admin",
      "subscriber",
      "super_admin",
      "prayer_centre_admin",
      "pastoral_care",
      "fullfillment",
      "prayer_centre_lead",
      "prayer_team",
      "prayer_team_voicemail",
      "c_suite",
      "account_manager",
      "demo_subscriber",
    ],
  },
  {
    path: "/reports",
    element: null, // Parent menu does not need a page
    allowedRoles: [
      "admin",
      "super_admin",
      "subscriber",
      "prayer_centre_admin",
      "c_suite",
      "account_manager",
      "demo_subscriber",
      // "pastoral_care",
      // "fullfillment",
      // "prayer_centre_lead",
      // "prayer_team",
    ],
  },
  {
    path: "/reports/types-of-calls",
    element: <TypesOfCalls />,
    allowedRoles: [
      "admin",
      "super_admin",
      "subscriber",
      "prayer_centre_admin",
      "c_suite",
      "account_manager",
      // "pastoral_care",
      // "fullfillment",
      // "prayer_centre_lead",
      // "prayer_team",
    ],
  },
  {
    path: "/reports/disposition",
    element: <Disposition />,
    allowedRoles: [
      "admin",
      "super_admin",
      "subscriber",
      "prayer_centre_admin",
      "c_suite",  
      "account_manager",
      "demo_subscriber",
      // "pastoral_care",
      // "fullfillment",
      // "prayer_centre_lead",
      // "prayer_team",
    ],
  },
  {
    path: "/reports/age-+-gender",
    element: <AgeGender />,
    allowedRoles: [
      "admin",
      "super_admin",
      "subscriber",
      "prayer_centre_admin",
      "c_suite",
      "account_manager",
      "demo_subscriber",
      // "pastoral_care",
      // "fullfillment",
      // "prayer_centre_lead",
      // "prayer_team",
    ],
  },
  {
    path: "/reports/resource",
    element: <ResourcesPage />,
    allowedRoles: [
      "admin",
      "super_admin",
      "subscriber",
      "prayer_centre_admin",  
      "c_suite",  "account_manager",  "demo_subscriber",
      // "pastoral_care",
      // "fullfillment",
      // "prayer_centre_lead",
      // "prayer_team",
    ],
  },
  {
    path: "/reports/calls-by-area-codes",
    element: <AreaCodesCalls />,
    allowedRoles: [
      "admin",
      "super_admin",
      "subscriber",
      "prayer_centre_admin",
      "c_suite",
      "account_manager",
      "demo_subscriber",
      // "pastoral_care",
      // "fullfillment",
      // "prayer_centre_lead",
      // "prayer_team",
    ],
  },
  {
    path: "/reports/requests",
    element: null, // Parent menu does not need a page
    allowedRoles: ["super_admin", "admin", "subscriber", "prayer_centre_admin", "c_suite", "account_manager", "demo_subscriber"],
  },
  {
    path: "/reports/requests/prayer-requests",
    element: <PrayerRequests />,
    allowedRoles: ["super_admin", "admin", "prayer_centre_admin","subscriber", "c_suite", "account_manager", "demo_subscriber"],
  },
  {
    path: "/reports/requests/voicemail-requests",
    element: <VoicemailReport />,
    allowedRoles: ["super_admin", "admin", "prayer_centre_admin", "c_suite", "account_manager"],
  },
  {
    path: "/reports/prayer-partner-hours",
    element: <VolunteerHours />,
    allowedRoles: [
      "admin",
      "super_admin",
      "subscriber",
      "c_suite",  "account_manager", "demo_subscriber",
      // "prayer_centre_admin",
      // "pastoral_care",
      // "fullfillment",
      // "prayer_centre_lead",
      // "prayer_team",
    ],
  },
  {
    path: "/reports/volunteer-reports",
    element: <VolunteerReport />,
    allowedRoles: [
      "admin",
      "super_admin",
      // "subscriber",
      "c_suite", 
      // "prayer_centre_admin",
      // "pastoral_care",
      // "fullfillment",
      // "prayer_centre_lead",
      // "prayer_team",
    ],
  },
  {
    path: "/reports/salvation-rededication",
    element: <SalvationRededication />,
    allowedRoles: [
      // "admin",
      "super_admin",  
      // "subscriber",
      // "prayer_centre_admin",
      // "c_suite",
    ],
  },
  {
    path: "/agent-interaction",
    element: null, // Parent menu does not need a page
    allowedRoles: [
      "admin",
      "super_admin",
      // "subscriber",
      "prayer_centre_admin",
      // "pastoral_care",
      // "fullfillment",
      "prayer_centre_lead",
      // "prayer_team",
    ],
  },
  {
    path: "/agent-interaction/blockcaller",
    element: <BlockCallerPage />,
    allowedRoles: [
      "prayer_centre_admin",
      "pastoral_care",
      "admin",
      "super_admin",
      "prayer_centre_lead",
    ],
  },
  {
    path: "/agent-interaction/prayer-partner-calllogs",
    element: <CallLogsPage />,
    allowedRoles: [
      "prayer_centre_admin",
      "super_admin",
      "prayer_centre_lead",
      "admin",
    ],
  },
  {
    path: "/agent-interaction/callform",
    element: <CallForm />,
    allowedRoles: ["pastoral_care", "super_admin", "admin"],
  },
  {
    path: "/pastoral-care",
    element: <AllFollowUp />,
    allowedRoles: ["pastoral_care", "super_admin"],
  },
  {
    path: "/pastoral-care/:followUpID",
    element: <DisplayFollowUp />,
    allowedRoles: ["pastoral_care", "super_admin"],
  },
  {
    path: "/pastoral-care/pastoral-calllogs",
    element: <CallLogs />,
    allowedRoles: ["pastoral_care", "super_admin"],
  },
  {
    path: "/pastoral-care/completed-follow-ups",
    element: <CompletedFollowUp />,
    allowedRoles: ["pastoral_care", "super_admin"],
  },
  {
    path: "/pastoral-care/new-follow-ups",
    element: <NewFollowUp />,
    allowedRoles: ["pastoral_care", "super_admin"],
  },
  {
    path: "/pastoral-care/ongoing-follow-ups",
    element: <OngoingFollowUp />,
    allowedRoles: ["pastoral_care", "super_admin"],
  },
  {
    path: "/resources",
    element: <Resources />,
    allowedRoles: ["fullfillment", "super_admin"],
  },
  {
    path: "/resources/inventory",
    element: <Inventory />,
    allowedRoles: ["fullfillment", "pastoral_care", "super_admin", "prayer_centre_admin"],
  },
  {
    path: "/resources/pastoral",
    element: <Pastoral />,
    allowedRoles: ["fullfillment", "super_admin"],
  },
  {
    path: "/resources/partner",
    element: <Agents />,
    allowedRoles: ["fullfillment", "super_admin"],
  },
  {
    path: "/resources/completed",
    element: <Completed />,
    allowedRoles: ["fullfillment", "super_admin"],
  },
  {
    path: "/resources/returned",
    element: <Returned />,
    allowedRoles: ["fullfillment", "super_admin"],
  },
  {
    path: "/resources/fulfilled",
    element: <Fulfilled />,
    allowedRoles: ["fullfillment", "super_admin"],
  },
  {
    path: "/resources/mailing-stats",
    element: <MailingStatsReport />,
    allowedRoles: ["pastoral_care", "fullfillment", "super_admin"],
  },
  {
    path: "/resources/:resourceRequestID",
    element: <ViewResourceRequest />,
    allowedRoles: ["fullfillment", "super_admin"],
  },
  {
    path: "/resources/returned/:resourceRequestID",
    element: <ViewReturnedResource />,
    allowedRoles: ["fullfillment", "super_admin"],
  },
  {
    path: "/requests",
    element: null, // Parent menu does not need a page
    allowedRoles: [
      "admin",
      "super_admin",
      // "subscriber",
      "prayer_centre_admin",
      // "pastoral_care",
      // "fullfillment",
      "prayer_centre_lead",
      // "prayer_team",
    ],
  },
  {
    path: "/requests/prayer-requests",
    element: <PrayerRequestDashboard />,
    allowedRoles: [
      "prayer_centre_admin",
      "admin",
      "super_admin",
      "prayer_centre_lead",
      "prayer_team",
    ],
  },
  {
    path: "/requests/voicemail",
    element: <VoicemailDashboard />,
    allowedRoles: [
      "admin",
      "super_admin",
      "prayer_centre_admin",
      "prayer_centre_lead",
      "prayer_team",
      "prayer_team_voicemail",
    ],
  },
  // Commented just for now, we need to identify to implement for few subscribers only, who has access to invoice that only can see the menu
  // {
  //   path: "/invoices",
  //   element: <InvoicePage />,
  //   allowedRoles: ["subscriber"],
  // },
  {
    path: "/mailing",
    element: <MailingResources />,
    allowedRoles: ["pastoral_care"],
  },

  {
    path: "/subscribers",
    element: <SubscribersPage />,
    allowedRoles: ["admin", "super_admin", "c_suite","account_manager"],
  },
  {
    path: "/testimony",
    element: <TestimonyPage />,
    allowedRoles: ["prayer_centre_admin", "super_admin", "admin","prayer_team"],
    },
    {
        path: "/users",
        element: <DashboardUsers />,
        allowedRoles: ["admin", "super_admin", "c_suite", "demo_subscriber"],
        name: "Users"
    },
   
{
   path: "/settings",
    element: null,
        allowedRoles: ["admin", "super_admin"],
            name: "Settings",
                icon: <FiSettings />,   
    },
{
    path: "/settings/field-settings",
        element: <FieldSettings />,
            allowedRoles: ["admin", "super_admin"],
                name: "Field Settings",
                    icon: <FiSliders />,   
    },
  
    {
        path: "/account",
        element: <AccountProfile />,
        allowedRoles: ["demo_subscriber"],
        name: "Account"
    },
];
